export interface StepProgress {
  step: string;
  displayName: string;
  status: 'completed' | 'current' | 'failed' | 'pending';
}

const FULL_INGEST_STEPS = [
  'lock',
  'backup', 
  'clear',
  'phase1',
  'phase2',
  'phase3',
  'phase4',
  'populate_fields',
  'base_data',
  'calculations',
  'restore_country_access',
  'grant_all_country_access',
  'unlock'
];

const NUMERICAL_INGEST_STEPS = [
  'lock',
  'clear_numerical',
  'update_sku_data',
  'phase4',
  'populate_fields',
  'base_data',
  'calculations',
  'recalculate_scenarios',
  'unlock'
];

export const getIngestStepProgress = (
  ingestType: 'full' | 'numerical',
  currentStep: string | null,
  status: 'running' | 'succeeded' | 'failed'
): StepProgress[] => {
  const steps = ingestType === 'full' ? FULL_INGEST_STEPS : NUMERICAL_INGEST_STEPS;
  const currentStepIndex = currentStep ? steps.indexOf(currentStep) : -1;
  
  return steps.map((step, index) => {
    let stepStatus: StepProgress['status'];
    
    if (status === 'succeeded') {
      stepStatus = 'completed';
    } else if (status === 'failed') {
      if (index < currentStepIndex) {
        stepStatus = 'completed';
      } else if (index === currentStepIndex) {
        stepStatus = 'failed';
      } else {
        stepStatus = 'pending';
      }
    } else if (status === 'running') {
      if (index < currentStepIndex) {
        stepStatus = 'completed';
      } else if (index === currentStepIndex) {
        stepStatus = 'current';
      } else {
        stepStatus = 'pending';
      }
    } else {
      stepStatus = 'pending';
    }
    
    return {
      step,
      displayName: getStepDisplayName(step) || step,
      status: stepStatus
    };
  });
};

const getStepDisplayName = (step: string): string => {
  const stepMap: Record<string, string> = {
    'lock': 'Locking out non-PwC staff',
    'phase4': 'Phase 4',
    'populate_fields': 'Populating fields',
    'base_data': 'Building base data',
    'calculations': 'Running calculations',
    'unlock': 'Unlocking non-PwC staff',
    'backup': 'Backing up country access for all users',
    'clear': 'Clearing data',
    'phase1': 'Phase 1',
    'phase2': 'Phase 2', 
    'phase3': 'Phase 3',
    'restore_country_access': 'Restoring country access for all users',
    'grant_all_country_access': 'Granting all PwC staff access to all countries',
    'clear_numerical': 'Clearing numerical data',
    'update_sku_data': 'Updating SKU data',
    'recalculate_scenarios': 'Recalculating scenarios'
  };
  
  return stepMap[step] || step;
};

